<template>
    <div>
        <div class="new_version_style">
            <el-row>
                <h1 class="project_head_title">利益冲突申报</h1>
                <el-divider class="divider" />
            </el-row>
            <el-form label-width="120px">
                <el-divider class="divider" />

                <el-row class="form-row">
                    <el-col :span="5">
                        <el-form-item label="关键词">
                            <el-input v-model="queryForm.person" placeholder="姓名/工号/部门/岗位"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="申报时间" prop="labelValue">
                                <el-date-picker
                                    style="width:100%;"
                                    v-model="dateRange"
                                    type="daterange"
                                    range-separator="至" 
                                    start-placeholde="开始日期" 
                                    end-placeholde="结束日期" 
                                    :default-time="['00:00:00','23:59:59']"
                                    value-format="timestamp"/>
                            </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="修改记录">
                            <el-select v-model="queryForm.type" clearable style="width:100%;" placeholder="请选择">
                                <el-option value="包含"/>
                                <el-option value="不包含"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="冲突">
                            <el-select v-model="queryForm.formData" clearable style="width:100%;" placeholder="请选择">
                                <el-option value='是' label="是"/>
                                <el-option value='否' label="否"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                            <el-button :disabled="loading" type="primary" icon="el-icon-search" @click="currentPage=1;getDataList()">搜索</el-button>
                            <!-- <el-button type="primary" icon="el-icon-download" @click="showDialog()">新增</el-button> -->
                            <el-button type="primary" @click="getDataList(true)">导出</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div v-loading="loading">
                <el-table class="tb-mini" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" border :data="datas" @selection-change="handleSelectionChange" align="center">
                    <el-table-column label="序号" type="index" width="70" align="center">
                        <template scope="scope">
                            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="姓名" show-overflow-tooltip width="100px"></el-table-column>
                    <el-table-column prop="no" label="工号" show-overflow-tooltip width="100px"></el-table-column>
                    <el-table-column prop="dept" label="部门" show-overflow-tooltip min-width="130px"></el-table-column>
                    <el-table-column prop="job" label="岗位" show-overflow-tooltip min-width="130px"></el-table-column>
                    <el-table-column prop="declareDateStr" label="申报日期" show-overflow-tooltip width="110px" ></el-table-column>
                    <el-table-column prop="status" label="状态" show-overflow-tooltip width="100px"></el-table-column>


                    <!-- <el-table-column prop="problemName" header-align="center" label="问题标题" width="240" show-overflow-tooltip>
                <template v-slot:header>
                    <el-tooltip placement="top">
                        <div slot="content">第一行<br/>第二行</div>
                        <span>标题</span>
                    </el-tooltip>
                </template>
            </el-table-column> -->




                    <el-table-column v-for="item in 9" :key="item" prop="status" show-overflow-tooltip min-width="150px">
                        <template v-slot:header>
                            <el-tooltip placement="top">
                                <div slot="content">
                                    <div v-html="brTitles[item]">
                                    </div>
                                </div>
                                <div>{{titles[item].substring(0,25)+'...'}}</div>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <span @click="showDialog(scope.row.guid,scope.row.form[item-1].key)" v-if="scope.row.form[item-1]" :style="{color:scope.row.form[item-1].whether=='是'?'red':'black'}" style="cursor:pointer;">{{scope.row.form[item-1].allDescribe}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column  label="操作" width="120px" fixed="right">
                        <template slot-scope="scope">
                            <!-- <el-button type="text" @click="showDialog(scope.row.guid)">修改</el-button> -->
                            <el-button type="text" @click="showDialog(scope.row.guid)">详情</el-button>
                            <!-- <el-button type="text" @click="deleteById(scope.row.guid)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[15, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    style="text-align:right"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" :title="dialogKey?'事项详情-'+names[dialogKey]:'详情'" width="1600px" :top="dialogKey?'10%':'5%'">
            <el-form label-width="120px" :rules="rules" ref="form" :model="dataForm" disabled style="padding-right:100px;">
                <el-row>
                    <el-col span="8">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="dataForm.name"/>
                        </el-form-item>
                    </el-col>
                    <el-col span="8">
                        <el-form-item label="工号" prop="no">
                            <el-input v-model="dataForm.no"/>
                        </el-form-item>
                    </el-col>
                    <el-col span="8">
                        <el-form-item label="部门" prop="dept">
                            <el-input v-model="dataForm.dept"/>
                        </el-form-item>
                    </el-col>
                    
                </el-row>
                <el-row>
                    <el-col span="8">
                        <el-form-item label="岗位" prop="job">
                            <el-input v-model="dataForm.job"/>
                        </el-form-item>
                    </el-col>
                    <el-col span="8">
                        <el-form-item label="申报日期" prop="dateStr">
                            <el-input v-model="dataForm.declareDateStr"/>
                        </el-form-item>
                    </el-col>
                    <el-col span="8">
                        <el-form-item label="状态" prop="status">
                            <el-input v-model="dataForm.status"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div v-for="(item,index) in dataForm.jsonForm" :key="index" v-if="dialogKey?(index+1)==dialogKey:true">
                    <el-row>
                        <el-col span="20">
                            <el-form-item :label="'事项'+(index+1)" prop="title">
                                <el-input v-model="titles[index+1]"/>
                            </el-form-item>
                        </el-col>
                        <el-col span="4">
                            <el-form-item label="利益冲突" prop="whether">
                                <el-input v-model="item.whether" :class="item.whether=='是'?'redInput':'black'"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
										<div v-if="index==0" class="item_tb_parent">
											<el-form-item label="详细列表" v-if="item.tables&&item.tables.length>0">
												<el-table :data="item.tables" stripe border
													:span-method="({row,column,rowIndex,columnIndex})=>{return columnIndex<4?[row.spanNum,1]:[1,1]}"
													class="interest_item_tb" :header-cell-style="{'text-align':'center'}">
													<el-table-column label="投资信息">
														<el-table-column label="类型" prop="type" width="90"/>
														<el-table-column label="姓名" prop="personName" width="100"/>
														<el-table-column label="工号" prop="personNo" width="100"/>
														<el-table-column label="手机号" prop="personPhone" width="160"/>
														<!-- <el-table-column label="所属部门" prop="orgFullPathName" min-width="250"/> -->
														<!-- <el-table-column label="任职岗位" prop="postName" width="160"/> -->
													</el-table-column>
													<el-table-column label="企业信息">
														<el-table-column label="企业编号" prop="companyId" width="190"/>
														<el-table-column label="企业名称" prop="companyName" min-width="200"/>
														<el-table-column label="模式" prop="mode" width="100"/>
														<el-table-column label="占比" prop="ratio" width="70">
															<template scope="scope">
																{{scope.row.ratio?`${scope.row.ratio}%`:''}}
															</template>
														</el-table-column>
														<el-table-column label="其他" prop="other" min-width="100"/>
													</el-table-column>
												</el-table>
											</el-form-item>
										</div>
										<div v-else-if="index==1" class="item_tb_parent">
											<el-form-item label="详细列表" v-if="item.tables&&item.tables.length>0">
												<el-table :data="item.tables" stripe border
													:span-method="({row,column,rowIndex,columnIndex})=>{return columnIndex<3?[row.spanNum,1]:[1,1]}"
													class="interest_item_tb" :header-cell-style="{'text-align':'center'}">
													<el-table-column label="企业信息">
														<el-table-column label="企业编号" prop="companyId" width="190"/>
														<el-table-column label="企业名称" prop="companyName" min-width="200"/>
														<el-table-column label="与三一集团关系" prop="companyRelationship" width="150"/>
													</el-table-column>
													<el-table-column label="关系人信息">
														<el-table-column label="关系" prop="relationship" width="150"/>
														<el-table-column label="姓名" prop="name" width="140"/>
														<el-table-column label="投资类型" prop="investmentType" width="120"/>
														<el-table-column label="占比" prop="ratio" width="70">
															<template scope="scope">
																{{scope.row.ratio?`${scope.row.ratio}%`:''}}
															</template>
														</el-table-column>
													</el-table-column>
												</el-table>
											</el-form-item>
										</div>
										<div v-else-if="index==2" class="item_tb_parent">
											<el-form-item label="详细列表" v-if="item.tables&&item.tables.length>0">
												<el-table :data="item.tables" stripe border
													:span-method="({row,column,rowIndex,columnIndex})=>{return columnIndex<3?[row.spanNum,1]:[1,1]}"
													class="interest_item_tb" :header-cell-style="{'text-align':'center'}">
													<el-table-column label="企业信息">
														<el-table-column label="企业编号" prop="companyId" width="190"/>
														<el-table-column label="企业名称" prop="companyName" min-width="200"/>
														<el-table-column label="企业关系" prop="corporateRelations" width="150"/>
													</el-table-column>
													<el-table-column label="关系人信息">
														<el-table-column label="关系" prop="relationship" width="150"/>
														<el-table-column label="姓名" prop="personName" width="140"/>
														<el-table-column label="手机号" prop="personPhone" width="160"/>
														<el-table-column label="任职岗位" prop="position" min-width="170"/>
													</el-table-column>
												</el-table>
											</el-form-item>
										</div>
										<div v-else-if="index==3" class="item_tb_parent">
											<el-form-item label="详细列表" v-if="item.tables&&item.tables.length>0">
												<el-table :data="item.tables" stripe border
													:span-method="({row,column,rowIndex,columnIndex})=>{return [1,1]}"
													class="interest_item_tb" :header-cell-style="{'text-align':'center'}">
														<el-table-column label="关系" prop="relationship" width="150"/>
														<el-table-column label="姓名" prop="personName" min-width="140"/>
														<el-table-column label="手机号" prop="personPhone" width="160"/>
														<el-table-column label="往来类型" prop="communicationType" width="100"/>
														<el-table-column label="个人姓名" prop="communicationPersonName" min-width="140"/>
														<el-table-column label="联系电话" prop="communicationPersonPhone" width="160"/>
														<el-table-column label="企业信用代码" prop="companyId" width="190"/>
														<el-table-column label="企业名称" prop="companyName" min-width="200"/>
												</el-table>
											</el-form-item>
										</div>
										<div v-else-if="index==4" class="item_tb_parent">
											<el-form-item label="详细列表" v-if="item.tables&&item.tables.length>0">
												<el-table :data="item.tables" stripe border
													:span-method="({row,column,rowIndex,columnIndex})=>{return columnIndex<3?[row.spanNum,1]:[1,1]}"
													class="interest_item_tb" :header-cell-style="{'text-align':'center'}">
													<el-table-column label="企业信息">
														<el-table-column label="任职单位类型" prop="companyType" width="120"/>
														<el-table-column label="企业编号" prop="companyId" width="190"/>
														<el-table-column label="企业名称" prop="companyName" min-width="200"/>
													</el-table-column>
													<el-table-column label="关系人信息">
														<el-table-column label="关系" prop="relationship" width="150"/>
														<el-table-column label="姓名" prop="personName" width="140"/>
														<el-table-column label="工号" prop="personNo" width="100"/>
														<el-table-column label="手机号" prop="personPhone" width="160"/>
														<el-table-column label="任职岗位" prop="position" min-width="170"/>
													</el-table-column>
												</el-table>
											</el-form-item>
										</div>
										<div v-else-if="index==5" class="item_tb_parent">
											<el-form-item label="详细列表" v-if="item.tables&&item.tables.length>0">
												<el-table :data="item.tables" stripe border
													class="interest_item_tb" :header-cell-style="{'text-align':'center'}">
														<el-table-column label="关系" prop="relationship" width="220"/>
														<el-table-column label="姓名" prop="personName" width="140"/>
														<el-table-column label="工号" prop="personNo" width="100"/>
														<el-table-column label="手机号" prop="personPhone" width="160"/>
														<el-table-column label="所属部门" prop="orgFullPathName" min-width="250"/>
														<el-table-column label="任职岗位" prop="postName" width="160"/>
												</el-table>
											</el-form-item>
										</div>
										<div v-else-if="index==7" class="item_tb_parent">
											<el-form-item label="详细列表" v-if="item.tables&&item.tables.length>0">
												<el-table :data="item.tables" stripe border
													:span-method="({row,column,rowIndex,columnIndex})=>{return columnIndex<4?[row.spanNum,1]:[1,1]}"
													class="interest_item_tb" :header-cell-style="{'text-align':'center'}">
													<el-table-column label="人员信息">
														<el-table-column label="关系" prop="relationship" width="80"/>
														<el-table-column label="姓名" prop="personName" width="140"/>
														<el-table-column label="工号" prop="personNo" min-width="100"/>
														<el-table-column label="手机号" prop="personPhone" width="160"/>
													</el-table-column>
													<el-table-column label="关系人信息">
														<el-table-column label="企业编号" prop="companyId" width="190"/>
														<el-table-column label="企业名称" prop="companyName" min-width="200"/>
														<el-table-column label="业务类型" prop="businessType" width="100"/>
														<el-table-column label="业务描述" prop="position" min-width="300"/>
													</el-table-column>
												</el-table>
											</el-form-item>
										</div>
										<div v-else-if="index==8" class="item_tb_parent">
											<el-form-item label="详细列表" v-if="item.tables&&item.tables.length>0">
												<el-table :data="item.tables" stripe border
													class="interest_item_tb" :header-cell-style="{'text-align':'center'}">
													<el-table-column label="干系人姓名" prop="personName" width="140"/>
													<el-table-column label="干系人工号" prop="personNo" width="120"/>
													<el-table-column label="岗位名称" prop="postName" min-width="100"/>
													<el-table-column label="部门全路径" prop="orgFullPathName" min-width="200"/>
													<el-table-column label="手机号" prop="personPhone" width="160"/>
													<el-table-column label="事项描述" prop="itemDesc" min-width="160"/>
												</el-table>
											</el-form-item>
										</div>
                    <el-row v-if="item.describe">
                        <el-col span="24">
                            <el-form-item label="描述" prop="whether">
                                <el-input v-model="item.describe" clearable type="textarea" :autosize="{minRows:1,maxRows:4}"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
								<el-form-item label="利益冲突附件" style="text-align: left;" v-if="fileLists.length>0">
									<Upload :disabled="true" :fileIds="fileLists"></Upload>
								</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return {
						fileLists:[],
            dateRange:[],
            detail:false,
            queryForm:{
                type:'不包含'
            },
            currentPage:1,
            pageSize:15,
            total: 0,
            datas: [],
            loading:false,
						dialogVisible:false,
						dialogKey:'',
            dataForm:{},
            rules:{
                labelValue:{required:true,message:'请填写数据',trigger:'blur'},
            },
            
            col:[],

						names:{
							'1':'经办企业',
							'2':'亲属经办企业与公司利益冲突',
							'3':'任职与兼职',
							'4':'经济往来',
							'5':'职务便利',
							'6':'亲属关系',
							'7':'保密与竞业协议',
							'8':'介绍业务',
							'9':'其他'
						},
            titles:{
                '1':'您是否以个人名义或通过他人，以独立或合资方式，或以承包、租赁等模式从事商业活动或创办企业？',
                '2':'您的直系亲属（包括配偶、子女、以及您和配偶的父母）是否以个人名义或与他人合资的方式（含通过控股公司、代持股份等间接方式）从事商业活动或创办企业，并且与三一集团有限公司的下属公司存在业务交易，或与三一集团经营的业务存在竞争关系？（公开市场上的股票、基金、债券及其衍生品投资，以及房产投资除外）',
                '3':'您或您的直系亲属是否在供应商、客户、代理商、竞争方任职、兼职（包括以咨询、顾问或名誉职务等其他类似身份从事的活动，不包括证书挂靠形式）。',
                '4':'您或您的直系亲属是否与您职权范围内的业务往来个人或单位（不包括银行机构）存在借款、贷款、融资担保或商业交易（含赊销、分期付款等非即时结清交易）或商务买卖行为？',
                '5':'您是否利用自身职权范围影响力或管辖公司资源，帮助个人及其亲属、同学、朋友等获取利益或相应的机会。（如商务人员介绍亲朋在自己管辖的供应商处任职，公司领导干部安排亲朋在自己手下任职等）',
                '6':'在您入职前或入职后，您是否有以下亲属在公司任职？包括：您配偶、您及配偶的父母、子女（及其配偶及配偶的父母）、祖父母/外祖父母；外甥/外甥女（及其配偶）；继父母、继子女（及其配偶及配偶的父母）；养父母、养子女（及其配偶及配偶的父母）；您及配偶的兄弟姐妹（及其配偶）；伯父/伯母；叔叔/婶婶；姑父/姑母；堂兄弟姐妹（及其配偶）；舅父/舅母；姨父/姨母；表兄弟姐妹（及其配偶）；侄子侄女（及其配偶）。',
                '7':'您是否在入职本公司之前与原用人单位签订了技术保密或竞业限制协议，并且该协议目前仍在有效期内？',
                '8':'您作为董事、关键岗位或核心岗位的人员，或您的关系人（包括亲友、同学、老乡）是否曾介绍供应商与三一公司开展业务？（包括基建施工、采购、外协、零部件加工，包括提供供应商推荐、参与供应商资质审核等环节）',
                '9':'最近36个月内，您是否涉及违反廉洁从业规定的行为？'
            },
            brTitles:{
                '1':'您是否以个人名义或通过他人，以独立或合资方式，或以承包、租赁等模式从事商业活动或创办企业？',
                '2':'您的直系亲属（包括配偶、子女、以及您和配偶的父母）是否以个人名义或与他人合资的方式<br/>（含通过控股公司、代持股份等间接方式）从事商业活动或创办企业，并且与三一集团有限公司的下属公司存在业务交易，或与三一集团经营的业务存在竞争关系？<br/>（公开市场上的股票、基金、债券及其衍生品投资，以及房产投资除外）',
                '3':'您或您的直系亲属是否在供应商、客户、代理商、竞争方任职、兼职（包括以咨询、顾问或名誉职务等其他类似身份从事的活动，不包括证书挂靠形式）。',
                '4':'您或您的直系亲属是否与您职权范围内的业务往来个人或单位（不包括银行机构）存在借款、贷款、融资担保或商业交易（含赊销、分期付款等非即时结清交易）或商务买卖行为？',
                '5':'您是否利用自身职权范围影响力或管辖公司资源，帮助个人及其亲属、同学、朋友等获取利益或相应的机会。<br/>（如商务人员介绍亲朋在自己管辖的供应商处任职，公司领导干部安排亲朋在自己手下任职等）',
                '6':'在您入职前或入职后，您是否有以下亲属在公司任职？<br/>包括：您配偶、您及配偶的父母、子女（及其配偶及配偶的父母）、祖父母/外祖父母；外甥/外甥女（及其配偶）；继父母、继子女（及其配偶及配偶的父母）；养父母、养子女（及其配偶及配偶的父母）；<br/>您及配偶的兄弟姐妹（及其配偶）；伯父/伯母；叔叔/婶婶；姑父/姑母；堂兄弟姐妹（及其配偶）；舅父/舅母；姨父/姨母；表兄弟姐妹（及其配偶）；侄子侄女（及其配偶）。',
                '7':'您是否在入职本公司之前与原用人单位签订了技术保密或竞业限制协议，并且该协议目前仍在有效期内？',
                '8':'您作为董事、关键岗位或核心岗位的人员，或您的关系人（包括亲友、同学、老乡）是否曾介绍供应商与三一公司开展业务？<br/>（包括基建施工、采购、外协、零部件加工，包括提供供应商推荐、参与供应商资质审核等环节）',
                '9':'最近36个月内，您是否涉及违反廉洁从业规定的行为？'
            },
        }
    },
    mounted(){
        this.getDataList()
    },
    methods:{
        showDialog(id,itemKey){
					this.dialogKey = itemKey
					this.dataForm = {}
					if(this.$refs['person']){
						this.$refs['person'].clearSelection()
					}
					if(this.$refs['form']){
						this.$refs['form'].resetFields()
					}
					this.fileLists = []
					if(id){
						this.$http.get('/api/ts/v0.1/interest/'+id)
						.then(res=>{
							this.dataForm = res.data
							this.dataForm.declareDateStr = this.$handlerDateToDay(this.dataForm.declareDate)
							this.dataForm.jsonForm = JSON.parse(this.dataForm.form).map((item,index)=>{
								item.tables = []
								if(index==0){
									item.persons&&item.persons.forEach(person=>{
										person.companys.forEach((company,companyIndex)=>{
											if(companyIndex==0){
												company.spanNum = person.companys.length
											}else{
												company.spanNum = 0
											}
											item.tables.push(Object.assign(company,person))
										})
									})
								}else if(index==1||index==2||index==4){
									item.companys&&item.companys.forEach(company=>{
										company.persons.forEach((person,personIndex)=>{
											if(personIndex==0){
												person.spanNum = company.persons.length
											}else{
												person.spanNum
											}
											item.tables.push(Object.assign(person,company))
										})
									})
								}else if(index==3||index==5||index==8){
									item.tables = item.persons
								}else if(index==7){
									item.persons&&item.persons.forEach(person=>{
										person.businesss.forEach((business,businessIndex)=>{
											if(businessIndex==0){
												business.spanNum = person.businesss.length
											}else{
												business.spanNum = 0
											}
											item.tables.push(Object.assign(business,person))
										})
									})
								}
								return item
							})
							if(res.data.files){
								this.fileLists = res.data.files.split(',')
							}
							this.dialogVisible = true
							console.log(this.dataForm)
						})
					}
        },
        deleteById(id){
            this.$confirm('此操作将永久删除该数据，是否继续？','提示'
                ,{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(()=>{
                    this.$http.delete('/api/ts/v0.1/interest/'+id).then(res=>{
                if (res.data >= 1) {
                    this.getDataList()
                    this.$message.success('操作成功')
                } else {
                    this.$message.error('操作失败')
                }
            }).catch((err)=>{
                this.$message.error('操作失败')
            })
                })
            
        },
        save(){
            console.log(this.dataForm,'1111111')
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    
                    this.$http.post('/api/ts/v0.1/interest/save',this.dataForm)
                    .then(res=>{
                        if (res.data >= 1) {
                            this.getDataList()
                            this.dialogVisible = false
                            this.$message.success('操作成功')
                        } else {
                            this.$message.error('操作失败')
                        }
                    })
                    .catch((err)=>{
                        this.$message.error('操作失败')
                    })
                }else{
                    this.$message.error('请填写数据')
                }
            })
            
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getDataList()
        },
        getDataList(isExport = false){
            this.queryForm.notForm = undefined
            this.queryForm.form = undefined
            if(this.queryForm.formData=='是'){
                this.queryForm.form = 'whether":"是"'
                this.queryForm.notForm = undefined
            }else if(this.queryForm.formData=='否'){
                this.queryForm.form = undefined
                this.queryForm.notForm = 'whether":"是"'
            }
            if(isExport){
                this.queryForm.pageSize = 10000000
                this.queryForm.pageNum = 1
                this.exportDatas = []
            }else{
                this.queryForm.pageSize = this.pageSize
                this.queryForm.pageNum = this.currentPage
                this.datas = []
            }
            if(this.dateRange){
                this.queryForm.dateStart = this.dateRange[0]
                this.queryForm.dateEnd = this.dateRange[1]
            }else{
                this.queryForm.dateStart = undefined
                this.queryForm.dateEnd = undefined
            }
            this.$http.get('/api/ts/v0.1/interest/page',{params:{...this.queryForm}})
                .then(res=>{
                    if(res.status==200){
                        res.data.list = res.data.list.map(item=>{
                            item.form = JSON.parse(item.form).map(data=>{
															data.allDescribe = ''
															let personNum = (data.persons&&data.persons.length)||0
															let companyNum = (data.companys&&data.companys.length)||0
															let businessNum = 0
															data.persons&&data.persons.forEach(person=>{
																companyNum += (person.companys&&person.companys.length)||0
																businessNum += (person.businesss&&person.businesss.length)||0
															})
															data.companys&&data.companys.forEach(company=>{
																personNum += (company.persons&&company.persons.length)||0
															})
															if(personNum){
																data.allDescribe+=(personNum+'个人员；')
															}
															if(companyNum){
																data.allDescribe+=(companyNum+'个企业；')
															}
															if(businessNum){
																data.allDescribe+=(businessNum+'个业务；')
															}
															if(data.describe){
																data.describe = '备注信息：'+data.describe
															}
															data.allDescribe = data.allDescribe+data.describe
															return data
														})
														item.declareDateStr = this.$handlerDateToDay(item.declareDate)
                            return item
                        })
                        if(isExport){
                            this.col = [['姓名','name'],['工号','no'],['部门','deptAll'],['岗位','job'],['申报日期','declareDateStr'],['状态','status']]
                            Object.keys(this.titles).forEach(key=>{
                                this.col.push([this.titles[key],'describe'+key])
																this.col.push(['是否冲突','whether'+key])
                            })
                            res.data.list = res.data.list.map((item)=>{
                                item.form.forEach((itm,index)=>{
                                    item['describe'+(index+1)] = itm.describe
																		item['whether'+(index+1)] = itm.whether
																		// debugger
                                })
                                
                                return item
                            })
                            console.log(this.col,res.data.list)
                            this.$onExport(res.data.list,this.col,"利益冲突表")
                        }else{
                            this.datas = res.data.list
                            this.total = res.data.total
                        }
                    }else{
                        this.$message.error('查询失败！请联系管理员')
                    }
                    
                    this.loading=false;
                })
                .catch((err)=>{
                    this.loading=false;
                    console.log(err)
                })
				}
    }
}
</script>

<style scoped>
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
			width: 100%;
    }
    .el-select{
			width:100%;
    }
    .el-input-number{
			width: 100%;
    }
		.interest_item_tb{
			/* margin-bottom: 20px; */
		}
		.item_tb_parent{
			/* padding-left: 120px; */
		}
		.project_head_title{
			font-size: 26px;
			color: #333;
			font-weight: 600;
		}
</style>